import { create } from 'zustand'

export const useSpinLoadStore = create((set) => ({
  SpinLoad: false,
  ShowLoad: () => set({SpinLoad: true }),
  HideLoad: () => set({ SpinLoad: false }),
}))